import { CashTypeEnum } from "@/model/data/enums/CashTypeEnum";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { GetErrorImageResData } from "./GetErrorImageResData";

const ENDPOINT = "/device_status/error_image";

export class GetErrorImageCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetErrorImageReqData = null;

    constructor(params: GetErrorImageReqData) {
        super();
        this.params = Object.assign({}, params);
    }

    public async execute(): Promise<GetErrorImageResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new GetErrorImageResData(res);
    }
}

export class GetErrorImageReqData {
    model: string = null;
    mask: string = null;
    supportedCashType: CashTypeEnum = null;

    constructor(model: string, mask: string, supportedCashType: CashTypeEnum) {
        this.model = model;
        this.mask = mask;
        this.supportedCashType = supportedCashType;
    }
}
